module.exports = __webpack_public_path__ + "img/thumbnail_BushDog_m_normal.274474d2.png";